import * as Cart from "../../../../network/api/cart";
import * as Wish from "../../../../network/api/wish";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import { useContext } from "react";
import { AddContext } from "../../Productdetails";
import { useTranslation } from "react-i18next";

function ButtonToAdd({ size, color, productQuantity, product, personal, update_p }) {
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [isAddedToWish, setIsAddedToWish] = useState(false);
  const [Error, setError] = useState("");
  const token = cookies.get("user");
  const [quantity, setNum] = useState(1);
  const {t} = useTranslation();
  
  

  const addToCart = async () => {
   
    
    await Cart.addCart(
      product?._id,
      color,
      size,
      product?.dressing,
      quantity, 
     
    ).then((e) => {
      if (e.status === 404) {
        setError(e.data.message);
        setTimeout(() => {
          setError("");
        }, 3000);
      }
      
      
      
      setNum(1);
      update_p();
    });
  };

  const addToWish = async () => {
    if (!isAddedToWish) {
      await Wish.addWish(product?._id).then((e) => {
        update_p();
        setIsAddedToWish(true); // Set the state to true after adding to wish list
      });
    }
  };
  const { setAddedCart } = useContext(AddContext);

  useEffect(() => {
    if (quantity <= 0) {
      setNum(1);
    }

    
  }, [quantity]);
  return (
    <div className="d-flex gap-2 flex-wrap">
      <div className="d-flex gap-1 nums ms-2 ">
        {quantity < +productQuantity && (
          <div className="plus" onClick={() => setNum(quantity + 1)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                fill="white"
              />
            </svg>
          </div>
        )}

        <div className="num">{quantity}</div>
        <div className="mins" onClick={() => setNum(quantity - 1)}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.3 13H5.7C5.51435 13 5.3363 12.8946 5.20503 12.7071C5.07375 12.5196 5 12.2652 5 12C5 11.7348 5.07375 11.4804 5.20503 11.2929C5.3363 11.1054 5.51435 11 5.7 11H18.3C18.4857 11 18.6637 11.1054 18.795 11.2929C18.9263 11.4804 19 11.7348 19 12C19 12.2652 18.9263 12.5196 18.795 12.7071C18.6637 12.8946 18.4857 13 18.3 13Z"
              fill="#A5A5A5"
            />
          </svg>
        </div>
      </div>
      <div className=" d-flex">
        {token ? (
          <div className="d-flex flex-column">
            <button
              className="cart"
              onClick={() => {
                addToCart();
                setAddedCart(true);
              }}
              // disabled={personal?.cart?.some((item) => item.id === product?._id && item.size === size)}
            >
              {personal?.cart?.some(
                (item) => item?.id === product?._id && item?.size === size
              )
                ? cartIcon
                : cartIcon}
              {personal?.cart?.some(
                (item) => item?.id === product?._id && item?.size === size
              )
                ? t("Added to cart")
                : t("Add to cart")}
            </button>
            <div className="text-danger text-start" clas>
              {Error}
            </div>
          </div>
        ) : (
          <Link
            to="#Login"
            data-bs-toggle="modal"
            style={{ textDecoration: "none" }}
          >
            <button className="cart">{cartIcon} {t("Add to cart")}</button>
          </Link>
        )}
        {/* ///////////////////////////////////////////////////////////////////////////////// */}
        {token ? (
          <button
            className="heart -block"
            onClick={() => {
              addToWish();
            }}
            disabled={personal?.wish?.includes(product?._id)}
          >
            {personal?.wish?.includes(product?._id)
              ? loveIconFill
              : loveIconNone}
          </button>
        ) : (
          <Link
            to="#Login"
            data-bs-toggle="modal"
            style={{ textDecoration: "none" }}
          >
            <button className="heart">{loveIconNone}</button>
          </Link>
        )}
      </div>
    </div>
  );
}
export default ButtonToAdd;

const cartIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 1.5H2.805C3.615 1.5 4.2525 2.1975 4.185 3L3.5625 10.47C3.4575 11.6925 4.425 12.7425 5.655 12.7425H13.6425C14.7225 12.7425 15.6675 11.8575 15.75 10.785L16.155 5.16C16.245 3.915 15.3 2.9025 14.0475 2.9025H4.36501"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1875 16.5C12.7053 16.5 13.125 16.0803 13.125 15.5625C13.125 15.0447 12.7053 14.625 12.1875 14.625C11.6697 14.625 11.25 15.0447 11.25 15.5625C11.25 16.0803 11.6697 16.5 12.1875 16.5Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.1875 16.5C6.70527 16.5 7.125 16.0803 7.125 15.5625C7.125 15.0447 6.70527 14.625 6.1875 14.625C5.66973 14.625 5.25 15.0447 5.25 15.5625C5.25 16.0803 5.66973 16.5 6.1875 16.5Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.75 6H15.75"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const loveIconNone = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
      stroke="#C99700"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const loveIconFill = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#C99700"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
      stroke="#C99700"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
